import { tzOffset } from '../../helpers/date-time';
import { LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { PaginationRequest, PaginationType } from '../../types/pagination';

import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export type ScanType = {
  browser: string;
  created_at: string;
  device_type: string;
  ip: string;
  os: string;
  id: string;
  name: LangType;
};

const baseUrl = `${managerApiUrl}/scans`;

export type FetchScansRequest = {
  branch?: string;
  from?: string;
  to?: string;
} & PaginationRequest;

export const fetchScans = async (
  params: FetchScansRequest,
): Promise<PaginationType & { logs: ScanType[] }> => {
  const response = await baseFetch(baseUrl + buildParams({...params, offset: -tzOffset}));
  return response;
};
